/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
import { createAsyncAction } from 'Helpers/redux'
import { Playlist } from 'Types/index'
import { apiCall } from './api'

export const GET_PLAYLISTS = createAsyncAction('GET_PLAYLISTS')
export const getPlaylists = (callback?: () => void) =>
  apiCall({
    method: 'get',
    endpoint: '/curator/get-playlists',
    types: GET_PLAYLISTS,
    callback,
  })

export const UPDATE_PLAYLISTS = createAsyncAction('UPDATE_PLAYLISTS')
export const updatePlaylists = (error: string, callback: () => void) =>
  apiCall({
    method: 'get',
    endpoint: '/curator/update-playlists',
    types: UPDATE_PLAYLISTS,
    callback,
  })

export const CHANGE_PLAYLIST_GENRES = createAsyncAction(
  'CHANGE_PLAYLIST_GENRES'
)
export const changePlaylistGenres = (
  playlistID: number,
  genres: Array<number>,
  callback: () => void
) =>
  apiCall({
    method: 'put',
    endpoint: '/curator/update-playlist-genres',
    query: {
      playlist_id: playlistID,
      genre_ids: genres,
    },
    types: CHANGE_PLAYLIST_GENRES,
    callback,
  })

export const CHANGE_PLAYLIST_INFORMATION = createAsyncAction(
  'CHANGE_PLAYLIST_INFORMATION'
)
export const changePlaylistInformation = (
  playlistID: number | string,
  genres: Array<number>,
  languages: Array<number>,
  moods: Array<number>,
  callback: () => void
) =>
  apiCall({
    method: 'put',
    endpoint: '/curator/update-playlist-genres',
    query: {
      playlist_id: playlistID,
      genre_ids: genres,
      language_ids: languages,
      mood_ids: moods,
    },
    types: CHANGE_PLAYLIST_INFORMATION,
    callback,
  })

export const CHECK_PLAYLIST = createAsyncAction('CHECK_PLAYLIST')
export const checkPlaylist = (playlist_url: string, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: '/curator/add-playlist',
    query: {
      playlist_url,
    },
    types: CHECK_PLAYLIST,
    callback,
  })

export const SET_PLAYLIST_GENRES_LIMIT = createAsyncAction(
  'SET_PLAYLIST_GENRES_LIMIT'
)
export const setPlaylistGenresLimit = () =>
  apiCall({
    method: 'post',
    endpoint: '/curator/playlist-genres',
    types: SET_PLAYLIST_GENRES_LIMIT,
  })

export const UPDATE_STATE_PLAYLISTS = 'UPDATE_STATE_PLAYLISTS'
export const updateStatePlaylists = (playlists: Array<Playlist>) => ({
  type: UPDATE_STATE_PLAYLISTS,
  payload: playlists,
})

export const GET_PLAYLISTS_LIST_ADMIN = createAsyncAction(
  'GET_PLAYLISTS_LIST_ADMIN'
)
export const getPlaylistsListAdmin = (tab: number, page: number) =>
  apiCall({
    method: 'get',
    endpoint: `/admin/playlists/${tab}/${page}`,
    types: GET_PLAYLISTS_LIST_ADMIN,
  })

export const SEARCH_PLAYLISTS = createAsyncAction('SEARCH_PLAYLISTS')
export const searchPlaylists = (str: string, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: '/admin/playlists-search',
    query: {
      str,
    },
    types: SEARCH_PLAYLISTS,
    callback,
  })

export const GET_PLAYLIST_INFO = createAsyncAction('GET_PLAYLIST_INFO')
export const getPlaylistInfo = (id: string | number, callback: () => void) =>
  apiCall({
    method: 'get',
    endpoint: `/admin/playlist-info/${id}`,
    types: GET_PLAYLIST_INFO,
    callback,
  })

export const ACTIVATE_PLAYLIST = createAsyncAction('ACTIVATE_PLAYLIST')
export const activatePlaylist = (id: string | number, callback: () => void) =>
  apiCall({
    method: 'put',
    endpoint: `/admin/playlist-activate/${id}`,
    types: ACTIVATE_PLAYLIST,
    callback,
  })

export const DEACTIVATE_PLAYLIST = createAsyncAction('DEACTIVATE_PLAYLIST')
export const deactivatePlaylist = (id: string | number, callback: () => void) =>
  apiCall({
    method: 'put',
    endpoint: `/admin/playlist-deactivate/${id}`,
    types: DEACTIVATE_PLAYLIST,
    callback,
  })

export const SET_IS_NEW_PARAMETER = 'SET_IS_NEW_PARAMETER'
export const setIsNewParameter = (playlist_id: string | number) => ({
  type: SET_IS_NEW_PARAMETER,
  payload: playlist_id,
})

export const SET_DEACTIVATION_ALERT_READ = createAsyncAction(
  'SET_DEACTIVATION_ALERT_READ'
)
export const setDeactivationAlertRead = (id: string | number) =>
  apiCall({
    method: 'put',
    endpoint: `/curator/deactivation-alert/${id}`,
    types: SET_DEACTIVATION_ALERT_READ,
  })

export const REFRESH_DISCOVERED_ON = createAsyncAction('REFRESH_DISCOVERED_ON')
export const refreshDiscoveredOn = (
  id: string | number,
  callback: () => void
) =>
  apiCall({
    method: 'put',
    endpoint: `/admin/playlist-discovered-on/${id}`,
    types: REFRESH_DISCOVERED_ON,
    callback,
  })

export const GET_SPOTIFY_PLAYLIST = createAsyncAction('GET_SPOTIFY_PLAYLIST')
export const getSpotifyPlaylist = (
  url: string,
  token: string,
  callback: () => void
) =>
  apiCall({
    method: 'get',
    endpoint: url,
    headers: { Authorization: `Bearer ${token}` },
    types: GET_SPOTIFY_PLAYLIST,
    callback,
  })

export const EDIT_PLAYLISTS_LANGUAGES = createAsyncAction(
  'EDIT_PLAYLISTS_LANGUAGES'
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const editPlaylistsLanguages = (playlists: any) =>
  apiCall({
    method: 'put',
    endpoint: '/curator/playlists',
    query: {
      playlists,
    },
    types: EDIT_PLAYLISTS_LANGUAGES,
  })
